// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-App-module__theme {
  height: 100%;
}
.src-App-module__theme .src-App-module__wrapper {
  height: 100%;
  flex-direction: column;
}
.src-App-module__theme .src-App-module__loader {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.src-App-module__body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: var(--color-bg-default);
}
.src-App-module__body .src-App-module__headerContainer {
  width: 100%;
  height: 10%;
  flex: 0 0 var(--space-4xl);
  overflow: hidden;
}
.src-App-module__body .src-App-module__bodyContainer {
  width: 100%;
  height: 95%;
}
.src-App-module__body .src-App-module__snackBar {
  width: 100%;
  justify-content: end;
}`, "",{"version":3,"sources":["webpack://./src/App.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,YAAA;EACA,sBAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,mCAAA;AADF;AAGE;EACE,WAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;AADJ;AAIE;EACE,WAAA;EACA,WAAA;AAFJ;AAKE;EACE,WAAA;EACA,oBAAA;AAHJ","sourcesContent":[".theme {\n  height: 100%;\n\n  .wrapper {\n    height: 100%;\n    flex-direction: column;\n  }\n\n  .loader {\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  background: var(--color-bg-default);\n\n  .headerContainer {\n    width: 100%;\n    height: 10%;\n    flex: 0 0 var(--space-4xl);\n    overflow: hidden;\n  }\n\n  .bodyContainer {\n    width: 100%;\n    height: 95%;\n  }\n\n  .snackBar {\n    width: 100%;\n    justify-content: end;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"theme": `src-App-module__theme`,
	"wrapper": `src-App-module__wrapper`,
	"loader": `src-App-module__loader`,
	"body": `src-App-module__body`,
	"headerContainer": `src-App-module__headerContainer`,
	"bodyContainer": `src-App-module__bodyContainer`,
	"snackBar": `src-App-module__snackBar`
};
export default ___CSS_LOADER_EXPORT___;
